(function () {
  angular.module('MktzapApp.Controllers')
    .controller('MessageWebhookController', messagewebhook);

  messagewebhook.$inject = ['$rootScope', 'FoundationApi', 'MessageWebhookService', 'NotificationService', 'CompanyService', 'StatusService'];

  function messagewebhook ($rootScope, FoundationApi, MessageWebhookService, NotificationService, CompanyService, StatusService) {
    var vm = this;
    vm.messageWebhook = {}
    vm.messageWebhookData = {}

    function reload () {
      MessageWebhookService
        .all()
        .$promise
        .then(function (data) {
          vm.messageWebhookData = data;
        }).catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorListWebhooks);
        });

    	    CompanyService
        .find(
          { id: $rootScope.user_data.company_id }
        )
        .$promise
        .then(function (data) {
          vm.company = data;
          if (!vm.messageWebhook) {
            vm.messageWebhook = {};
            vm.messageWebhook.company_id = vm.company.id;
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });

      StatusService
        .should_close_statuses()
        .$promise
        .then(function (data) {
          vm.shouldCloseStatuses = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });

      StatusService
        .classification_statuses()
        .$promise
        .then(function (data) {
          vm.classificationStatuses = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }
    reload();

    vm.addMessageWebhook = function () {
      vm.messageWebhook = {};
      FoundationApi.publish('addMessageWebhookModal', 'open');
    }

    vm.editMessageWebhook = function (messageWebhook_id) {
      MessageWebhookService
        .findOne({ id: messageWebhook_id })
        .$promise
        .then(function (data) {
          vm.messageWebhook = data;
          if (vm.messageWebhook.channel_type.indexOf('WhatsappWeb') != -1) {
            vm.channel_type = 'WhatsappWeb';
          }
          if (vm.messageWebhook.channel_type.indexOf('Waent') != -1) {
            vm.channel_type = 'Waent';
          }
          FoundationApi.publish('addMessageWebhookModal', 'open');
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }

    vm.deleteMessageWebhook = function (messageWebhook, index) {
      FoundationApi.publish('confirmDeleteModal', 'close');

      MessageWebhookService
        .delete(
          { id: vm.deleting.id }
        )
        .$promise
        .then(function (data) {
          reload()
          NotificationService.successHandler(data, $rootScope.labels.successDelData);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.requestError);
        });
    }

    vm.saveMessageWebhook = function (messageWebhook) {
      vm.messageWebhook = messageWebhook
      vm.messageWebhook.channel_type = vm.channel_type
      if (vm.messageWebhook.id === undefined) {
        MessageWebhookService
          .create(
            {},
            messageWebhook
          )
          .$promise
          .then(function (data) {
            vm.messageWebhook = data
            reload()
            NotificationService.successHandler(data, $rootScope.labels.savedWithSuccess);
            FoundationApi.publish('addMessageWebhookModal', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, error.message);
          });
      } else {
        MessageWebhookService
          .update(
            { id: vm.messageWebhook.id },
            messageWebhook
          )
          .$promise
          .then(function (data) {
            vm.messageWebhook = data
            reload()
            NotificationService.successHandler(data, $rootScope.labels.updatedWithSuccess);
            FoundationApi.publish('addMessageWebhookModal', 'close');
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, error.message);
          });
      }
    }

    vm.confirmDelete = function (messageWebhook) {
      vm.deleting = messageWebhook
      FoundationApi.publish('confirmDeleteModal', 'open');
    }

    vm.updateStatusOptions = function (type) {
      if (type == 'classification') {
        vm.messageWebhook.should_close_status_id = null;
      }

      if (type == 'should_close') {
        vm.messageWebhook.classification_status_id = null;
      }
    }
  }
})();
